"use server";

import {
  addBodyTypeSchema,
  editBodyTypeSchema,
  deleteBodyTypeSchema,
} from "@/lib/schemas/body-types";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { requireServerRole } from "@/lib/guards";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteBodyType(
  params: z.infer<typeof deleteBodyTypeSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteBodyTypeSchema, params);

    await prisma.bodyType.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addBodyType(
  params: z.infer<typeof addBodyTypeSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name } = validateParams(addBodyTypeSchema, params);

    const bodyType = await prisma.bodyType.create({
      data: { name, isActive: true },
    });

    return { success: true, data: bodyType };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editBodyType(
  params: z.infer<typeof editBodyTypeSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      isActive = true,
    } = validateParams(editBodyTypeSchema, params);

    const bodyType = await prisma.bodyType.update({
      where: { id },
      data: { name, isActive },
    });

    return { success: true, data: bodyType };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
